import {
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from '@heroicons/react/20/solid';
export interface PaginatorProps {
  page: number;
  pageCount: number;
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (page: number) => any;
}

export default function Paginator(props: PaginatorProps) {
  const { page = 0, pageCount = 0, totalItems = 0, itemsPerPage = 0, onPageChange } = props;
  const startPage = Math.max(1, Math.min(page - 2, pageCount - 4));
  const selectedClasses =
    'z-10 inline-flex size-10 items-center justify-center bg-indigo-200 text-indigo-700 ring-1 ring-inset ring-gray-300';
  const unselectedClasses =
    'inline-flex size-10 items-center justify-center text-gray-500 ring-1 ring-inset ring-gray-300';
  const paginatorNumbersToShow = Array.from(
    { length: Math.min(5, pageCount) },
    (_, i) => startPage + i,
  ).map(
    pageNum =>
      pageNum <= pageCount &&
      pageNum > 0 && (
        <a
          key={pageNum}
          onClick={() => onPageChange(pageNum)}
          aria-current="page"
          className={pageNum === page ? selectedClasses : unselectedClasses}
        >
          {pageNum}
        </a>
      ),
  );

  if (pageCount < 1) return null;
  return (
    <div className="flex w-full items-center justify-between text-sm">
      <div className="text-gray-500">
        <span>Showing</span>
        <span className="font-semibold text-gray-900">
          {' '}
          {(page - 1) * itemsPerPage + 1} -{' '}
          {(page - 1) * itemsPerPage + itemsPerPage > totalItems
            ? totalItems
            : (page - 1) * itemsPerPage + itemsPerPage}
        </span>
        <span> of </span>
        <span className="font-semibold text-gray-900">{totalItems}</span>
      </div>

      <nav
        className="isolate inline-flex -space-x-px rounded-md font-medium shadow-sm hover:cursor-pointer [&>a:first-child]:rounded-l-md [&>a:last-child]:rounded-r-md"
        aria-label="Pagination"
      >
        <a onClick={() => onPageChange(1)} className={unselectedClasses}>
          <span className="sr-only">First</span>
          <ChevronDoubleLeftIcon className="size-5" aria-hidden="true" />
        </a>
        <a onClick={() => onPageChange(page - 1 || 1)} className={unselectedClasses}>
          <span className="sr-only">Previous</span>
          <ChevronLeftIcon className="size-5" aria-hidden="true" />
        </a>
        {paginatorNumbersToShow}
        <a
          onClick={() => onPageChange(page + 1 > pageCount ? pageCount : page + 1)}
          className={unselectedClasses}
        >
          <span className="sr-only">Next</span>
          <ChevronRightIcon className="size-5" aria-hidden="true" />
        </a>
        <a onClick={() => onPageChange(pageCount)} className={unselectedClasses}>
          <span className="sr-only">Last</span>
          <ChevronDoubleRightIcon className="size-5" aria-hidden="true" />
        </a>
      </nav>
    </div>
  );
}
